import React from 'react'
import { serviceDetails } from '../../../content/site'

// Rebuilt on the new design (Task 8): alternating two-column layout (prose one side, the
// pair of photographs the other), not .service-card - that primitive is sized for Home's
// one-line blurbs and would shrink these photographs to thumbnails. See the SERVICE PAGES
// banner in src/css/site/site.css.
//
// The middle paragraph line carries the NVISALIGN brand mark, bold with the 'NVIS' half in
// the accent colour in the original markup (<b><span>NVIS</span>ALIGN</b>) - reproduced here
// by splitting the plain-text line from serviceDetails on the literal substring, so the
// styling is applied here rather than duplicating the sentence into this file.
const Aligners = () => {
  const s = serviceDetails.services.find((x) => x.key === 'aligners')
  return (
    <section id={s.id} className={`section service-detail${s.alt ? ' is-alt' : ''}`}>
      <div className="container service-detail-inner">
        <div className="service-detail-copy">
          <h2 className="section-title">{s.title}</h2>
          <p className="section-sub service-detail-desc">
            {s.paragraph.map((line, i) => {
              const brandIdx = line.indexOf('NVISALIGN')
              return (
                <React.Fragment key={i}>
                  {i > 0 && <br />}
                  {brandIdx === -1 ? (
                    line
                  ) : (
                    <>
                      {line.slice(0, brandIdx)}
                      <b><span className="service-detail-brand">NVIS</span>ALIGN</b>
                      {line.slice(brandIdx + 'NVISALIGN'.length)}
                    </>
                  )}
                </React.Fragment>
              )
            })}
          </p>
        </div>
        <div className="service-detail-photos">
          {s.images.map((img, i) => (
            <img key={i} src={img.src} alt={img.alt} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Aligners
